<template>
  <!--  v-sticky="{ zIndex: 9, stickyTop: 146}" -->
  <div class="jin-form-head" :class="{'jin-form-head-none': info.isAdd && !(info.formList && info.formList.length)}">
    <h3>{{ info.title }}</h3>
    <span v-if="info.isAdd" @click="handleApp"><Icon name="add" />添加</span>
  </div>
</template>

<script>
import VueSticky from 'vue-sticky'

export default {
  directives: {
    'sticky': VueSticky
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          title: '基本信息'

        }
      }
    }
  },
  data() {
    return {

    }
  },
  methods: {
    handleApp() {
      this.$emit('onAdd')
    }
  }
}
</script>

<style lang="scss" scoped>
.jin {
  &-form {
    &-head {
      background: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 6px;
      border-bottom: 1px solid #e8e8ea;
      transition: all 0.3s;

      &-none {
        height: 60px;
        box-sizing: border-box;
        padding: 18px 20px;
        background: #f4f5f9;
        border-radius: 4px;
        margin-bottom: 20px;
        border-bottom: none;
      }

      h3 {
        font-size: 18px;
        font-weight: 500;
        color: #3d4351;
        line-height: 25px;
      }

      span {
        cursor: pointer;
        font-size: 14px;
        color: #4777f4;
        line-height: 20px;

        i {
          margin-right: 2px;
        }
      }
    }
  }
}
</style>
